export const languages = ['EN', 'RU']
